export default "__VITE_ASSET__c0a4dd7d__"